import React from 'react';
import styles from './Masthead.module.scss';

export default function Masthead() {
    return (
        <section className={styles.Main}>
            <div className="container">
                <h1 className={styles.Title}>
                    Les 10 évènements <br/>
                    boursiers en 2022
                </h1>

                <div className={styles.Description}>
                    L’année 2022 aura été celle de tous les dangers sur les marchés financiers. Les marchés ont dû faire face à une envolée historique de l’inflation sur des niveaux oubliés depuis 40 ans sur fond de pénurie énergétique et de retour de la guerre en Europe.
                </div>
            </div>
        </section>
    )
}